import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M635.819 15.36c274.261 68.437 441.258 346.197 372.821 620.544-68.352 274.261-346.197 441.173-620.544 372.736C113.749 940.203-53.077 662.443 15.36 388.181 83.797 113.877 361.515-53.12 635.819 15.36zm-10.326 41.387c-251.392-62.72-506.026 90.282-568.746 341.76C-5.973 649.94 146.944 904.49 398.42 967.253c251.478 62.72 506.155-90.282 568.832-341.674 62.72-251.435-90.325-506.112-341.76-568.832zM779.947 681.77c25.6 0 51.413-18.39 77.354-55.168 19.2-27.52 28.758-62.251 28.758-104.192 0-8.832-.683-18.688-2.048-29.483a86.4 86.4 0 00-24.363-51.115c-6.315-6.4-13.397-13.525-21.248-21.205l-26.24 55.552c31.019 27.221 46.635 48.64 46.89 64.213 0 7.083-9.3 22.23-27.86 45.526-18.603 23.253-40.747 35.541-66.475 36.821a129.621 129.621 0 01-18.774-.853 87.85 87.85 0 01-15.914-3.584c-5.163-1.664-10.454-3.84-15.915-6.528a638.928 638.928 0 01-18.816-9.814l-10.41-6.4c6.655 19.542 19.37 38.827 38.1 57.771 18.689 18.944 37.675 28.459 56.96 28.459zM627.2 562.176c17.365 0 26.027-8.747 26.027-26.24a25.941 25.941 0 00-6.912-18.432 23.467 23.467 0 00-17.92-7.424c-18.176 0-27.222 8.832-27.222 26.453 0 7.68 2.39 13.91 7.254 18.603 4.778 4.693 11.093 7.04 18.773 7.04zm-415.488 99.541c40.533-.426 83.328-15.573 128.47-45.525 12.842-9.643 21.333-27.648 25.471-54.016 22.23 0 36.651-1.493 43.179-4.437 14.933-5.547 25.813-11.094 32.597-16.811 9.814 4.395 22.059 8.96 36.864 13.824 14.806 4.821 34.39 7.808 58.838 8.96 7.21 0 14.037-.427 20.522-1.28 6.486-.81 10.923-3.115 13.227-6.827 3.456-6.698 5.12-31.36 4.992-74.069.128-27.52-2.859-50.603-9.045-69.248l-38.4 38.955c6.442 10.41 10.88 25.6 13.312 45.525 0 2.432-1.622 4.95-4.907 7.552-3.285 2.56-9.301 4.096-18.048 4.608-22.357 0-41.728-6.613-58.027-19.883 7.168-15.274 11.478-27.392 12.8-36.352 1.366-8.96 2.048-16.64 2.048-23.253a39.253 39.253 0 00-1.365-9.813l-40.107 42.24c1.152 2.048 1.664 7.082 1.536 15.061-.64 9.387-2.389 15.616-5.205 18.688-3.243 3.584-8.704 5.419-16.384 5.419h-45.91c-2.09-36.267-10.666-64.171-25.685-83.712l-32.768 48.768c3.328 4.01 7.68 12.885 13.099 26.624 5.419 13.781 9.045 25.856 10.923 36.266 1.834 10.411 2.773 18.603 2.773 24.491 0 6.57-.512 12.416-1.536 17.579-1.408 3.2-9.643 7.85-24.704 13.866-36.907 13.91-68.096 20.822-93.525 20.822-24.192 0-41.643-6.016-52.395-18.091-10.71-12.117-15.957-27.776-15.701-47.104-.256-13.61 4.48-32.427 14.165-56.405 9.728-23.979 16.427-39.296 20.181-45.995-5.546 1.792-12.97 9.045-22.314 21.675-9.302 12.672-17.024 28.245-23.126 46.72a190.123 190.123 0 00-9.173 60.074c0 19.542 1.45 35.414 4.352 47.744 2.901 12.246 7.637 21.931 14.165 29.014 6.571 7.082 15.147 11.904 25.771 14.506 10.581 2.56 23.637 3.84 39.04 3.84z"
});

function SvgSar(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "SAR_svg__icon",
    width: 200,
    height: 200,
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSar);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'SAROutlined';

export default KuFoxIcons;
